import {WbAgentApiError} from '../../aria/client/WbAgentClient';

/**
 * extractErrorMessage extracts a human-readable message from an unknown throw
 * value.
 */
export function extractErrorMessage(err: unknown): string {
  if (err instanceof Error) {
    return err.message;
  }

  if (typeof err === 'string') {
    return err;
  }

  return 'Unknown error';
}

/**
 * Copy shown under an assistant message when its turn did not complete. The
 * backend never sends user-facing text for a failed turn, so the client owns
 * every message here.
 */
export const GENERIC_RUN_ERROR_MESSAGE = 'Stopped before turn completed';
export const QUOTA_EXCEEDED_RUN_ERROR_MESSAGE =
  'Stopped because your usage quota was exceeded. Check your plan and billing details to continue.';

const HTTP_PAYMENT_REQUIRED = 402;

/**
 * runErrorMessage maps a failure raised while running a turn to the copy shown
 * to the user. A 402 from wb_agent means the usage allowance is exhausted;
 * everything else gets the generic line.
 */
export function runErrorMessage(err: unknown): string {
  if (err instanceof WbAgentApiError && err.status === HTTP_PAYMENT_REQUIRED) {
    return QUOTA_EXCEEDED_RUN_ERROR_MESSAGE;
  }
  return GENERIC_RUN_ERROR_MESSAGE;
}
